















































import { Vue, Component, Prop, Watch } from "@/shared/vuepack";
import {
  EmployerBankSettingsRequest,
  MassTransitManualClaimStatus
} from "@/shared/types";
import moment from "moment";
import * as _ from "lodash";
import { useEmployerBankSettingsStore } from "@/shared/store/employerBankSettings";
import { useNotifierStore } from "@/shared/store/notifier";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";
import { massTransitManualClaimStatusIcon } from "@/shared/awesomeIconMapper";

@Component
export default class EmployerMassTransitSettingsForm extends Vue {
  employerBankSettings = useEmployerBankSettingsStore();
  notifierStore = useNotifierStore();
  featureFlagStore = useFeatureFlagStore();

  isSubmitting = false;

  formModel: EmployerBankSettingsRequest = {
    dateMassTransitEnd: null,
    dateMassTransitStart: null,
    employerId: 0
  };

  @Prop({ required: true })
  employerId: number;

  @Prop({ default: true })
  greyBackground: boolean;

  @Watch("employerBankSettings.isLoaded")
  apply () {
    this.initializeFromStateValue();
  }
  beforeMount () {
    this.$validator.extend("dateAfter", {
      getMessage: _ => "End date must be after the Start date.",
      validate: _ => {
        if (!this.formModel.dateMassTransitEnd) {
          return true;
        }
        const result = moment(this.formModel.dateMassTransitStart) < moment(this.formModel.dateMassTransitEnd);
        if (result) {
          this.$validator.reset();
        }
        return result;
      }
    });
  }
  async mounted () {
    await this.employerBankSettings.getEmployerBankSettings({employerId: this.employerId, force: true});
  }

  get isLoaded (): boolean {
    return this.employerBankSettings.isLoaded;
  }
  get validateStartDate () {
    if (this.formModel.dateMassTransitEnd) {
      return `required`;
    }
    return "";
  }
  get validateEndDate () {
    if (this.formModel.dateMassTransitStart) {
      return `dateAfter`;
    }
    return "";
  }
  onSubmit (formModel: EmployerBankSettingsRequest): void {
    this.$validator.validateAll()
        .then(isValid => {
          if (!isValid) {
            return;
          }
          this.formModel.employerId = this.employerId;
          this.isSubmitting = true;
          this.employerBankSettings.putEmployerBankSettings(formModel)
              .then(() => {
                this.notifierStore.setSuccess("Mass Transit Settings have been updated");
              })
              .finally(() => { this.isSubmitting = false; });
        });
  }
  initializeFromStateValue () {
    if (!this.employerBankSettings.isLoaded) {
      return;
    }
    this.formModel = _.cloneDeep({
      employerId: this.employerId,
      dateMassTransitStart: this.employerBankSettings.settings.dateMassTransitStart,
      dateMassTransitEnd: this.employerBankSettings.settings.dateMassTransitEnd,
    });
  }
  get isFormEnabled (): boolean {
    return this.featureFlagStore.featureFlagsAvailable
        && this.featureFlagStore.flags.bend22264EnableMassTransitPlanSettings;
  }
  get statusIcon () {
    return massTransitManualClaimStatusIcon[this.employerBankSettings.bankSettings.status];
  }
  get statusTitle () {
    switch (this.employerBankSettings.bankSettings.status) {
      case MassTransitManualClaimStatus.Active:
        return "Consumers can submit manual expenses";
      case MassTransitManualClaimStatus.WillBeActiveOnFutureDate:
        return `Will be active on ${moment(this.employerBankSettings.settings.dateMassTransitStart).format("MM/DD/YYYY")}`;
    }
    return "Consumers can not submit manual expenses";
  }
}
